import {
  GridItem,
  Heading,
  HeadingProps,
  SimpleGrid,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import React from 'react';

type GalleryProps =
  | {
      layout: 'WRAP';
      spacing: number | number[];
      children?: React.ReactNode[] | null | undefined;
    }
  | {
      layout: 'FIXED';
      minChildWidth?: React.ComponentProps<typeof SimpleGrid>['minChildWidth'];
      maxWidth?: React.ComponentProps<typeof SimpleGrid>['maxWidth'];
      spacing?: React.ComponentProps<typeof SimpleGrid>['spacing'];
      spacingX?: React.ComponentProps<typeof SimpleGrid>['spacingX'];
      spacingY?: React.ComponentProps<typeof SimpleGrid>['spacingX'];
      paddingX?: React.ComponentProps<typeof SimpleGrid>['paddingX'];
      marginTop?: React.ComponentProps<typeof SimpleGrid>['marginTop'];
      marginBottom?: React.ComponentProps<typeof SimpleGrid>['marginBottom'];
      width?: string;
      columns: React.ComponentProps<typeof SimpleGrid>['columns'];
      justifyItems?: React.ComponentProps<typeof SimpleGrid>['justifyItems'];
      padding?: React.ComponentProps<typeof SimpleGrid>['padding'];
      children?: React.ReactNode[] | null | undefined;
    };

const Gallery: React.FC<GalleryProps> = (props) => {
  if (props.layout === 'WRAP') {
    return (
      <Wrap {...props} width="full">
        {React.Children.map(props.children, (child, index) => (
          <WrapItem key={index}>{child}</WrapItem>
        ))}
      </Wrap>
    );
  } else if (props.layout === 'FIXED') {
    return (
      <SimpleGrid
        {...props}
        width={props.width || 'full'}
        style={{ marginTop: '0px' }}
        spacing={props.spacing || [3, null, 6]}
      >
        {props.children}
      </SimpleGrid>
    );
  }
  return null;
};

export default Gallery;
